import { render } from "./SireHeader.vue?vue&type=template&id=c0861292&scoped=true&ts=true"
import script from "./SireHeader.vue?vue&type=script&lang=ts"
export * from "./SireHeader.vue?vue&type=script&lang=ts"

import "./SireHeader.vue?vue&type=style&index=0&id=c0861292&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0861292"]])

export default __exports__